import { PartTypeSchema, PartTypeType } from "../types";

export const isRoundPartType = (partType: PartTypeType | undefined | null): boolean => {
  if (!partType) {
    return false;
  }

  switch (partType) {
    case PartTypeSchema.enum.ROUND_TUBE:
    case PartTypeSchema.enum.ROUND_BAR:
      return true;
    default:
      return false;
  }
};
